/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Kind_Bear_CoilInputs */

const en_bold_kind_bear_coil = /** @type {(inputs: Bold_Kind_Bear_CoilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const de_bold_kind_bear_coil = /** @type {(inputs: Bold_Kind_Bear_CoilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Bold_Kind_Bear_CoilInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_kind_bear_coil = /** @type {((inputs?: Bold_Kind_Bear_CoilInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Kind_Bear_CoilInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_kind_bear_coil(inputs)
	return de_bold_kind_bear_coil(inputs)
});